"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetGalleryFieldIsTitleGallery = OfferAssetGalleryFieldIsTitleGallery;
const jsx_runtime_1 = require("react/jsx-runtime");
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const types_1 = require("@src/types");
const TitleGalleryFormItemLabel_1 = require("./TitleGalleryFormItemLabel");
function OfferAssetGalleryFieldIsTitleGallery({ fieldName, openTitleGalleryInfoModal }) {
    const handleIsTitleGalleryLabelClick = (e) => {
        e.preventDefault();
        openTitleGalleryInfoModal();
    };
    return ((0, jsx_runtime_1.jsx)(antd_1.Form.Item, { name: [fieldName, types_1.EOfferGalleryKey.isTitleGallery], label: (0, jsx_runtime_1.jsx)(TitleGalleryFormItemLabel_1.TitleGalleryFormItemLabel, { onClick: handleIsTitleGalleryLabelClick }), valuePropName: "checked", children: (0, jsx_runtime_1.jsx)(elements_1.Switch, {}) }));
}
